// extracted by mini-css-extract-plugin
module.exports = {"searchingContainer":"styles_searchingContainer__2Z8nk","notFound":"styles_notFound__fbzcU"};